<template>
  <div :class="getCss('wrap')"
       ref="playVideoContainer"
       :style="{...styles.base,...bgImageStyle}">

    <div ref="defaultPLayVideo"
         :style="defaultPLayVideoStyle">
    </div>
    <div
      :class="getCss('video-container')"
      ref="videoContainerMask"
      v-transfer-dom
      v-show="isShowVideoPlay"
    >
      <div ref="popVideo" :style="popVideoStyle" :class="getCss('video-content')"></div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import SuperPlayer, { AUTO_PLAY_POLICY, END_STATE, H5_PLAY_EVENT } from '@tencent/super-player';
// 当自动播放被浏览器阻止以后，尝试静音播放
// const PLAT_TYPE_VIA_VID = 'vid'; // 传vid
// const PLAT_TYPE_VIA_URL = 'url';// 传url
const PLAT_TYPE_VOD = 'vod';// 点播
const PLAT_TYPE_LIVE = 'live';// 直播
const PLAT_TIME_PER_DAY_RANGE = 'day';// 直播
const PLAT_TIME_CUSTOM_RANGE = 'custom';// 直播

const PLAY_POSITION_POP_WINDOW = 2; // 弹框播放
const PLAY_POSITION_DEFAULT = 1; //  默认播放不弹框
// let playerInstance = null;
export default {
  name: 'CVideo',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'video-',
      isShowVideoPlay: false,
      prePlayBgImg: '',
      ZIndex: 0,
      init: false,
      domId: '',
    };
  },
  computed: {
    defaultPLayVideoStyle() {
      return {
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    // isContainerPlay() {
    //   if (!this.$refs.playVideoContainer) {
    //     return false;
    //   }
    //   // eslint-disable-next-line no-underscore-dangle
    //   return  !this.$refs.playVideoContainer.parentNode.classList.contains('page-content');
    // },
    // 1  默认播放
    // 2  弹框播放
    playType() {
      return this.configurationData.playType || PLAY_POSITION_DEFAULT;
    },
    postUrl() {
      const { prePlayBgImg = 1, autoPlay = true } = this.configurationData;
      if (prePlayBgImg && this.playType === PLAY_POSITION_DEFAULT && autoPlay === true) {
        return prePlayBgImg;
      }
      return '';
    },
    popVideoStyle() {
      const { popPlayContainerWidth = 750, popPlayContainerHeight = 480 } = this.configurationData;
      let style = { width: `${popPlayContainerWidth || 750}px`, height: `${popPlayContainerHeight || 480}px` };
      if (this.deviceMode === 'pc') {
        return style;
      }
      style = common.tool.transformStyle(style);
      console.log('popVideoStyle =,', style);
      return style;
    },
    bgImageStyle() {
      const { prePlayBgImg } = this;
      const { bgDisplayType = 1 } = this.configurationData;
      // bgDisplayType  === 1 图片大小缩放
      // bgDisplayType  === 2 区域大小缩放
      return {
        backgroundImage: prePlayBgImg ? `url('${prePlayBgImg}')` : 'none',
        backgroundSize: bgDisplayType === 1 ? '100% 100%' : 'contain',
        backgroundRepeat: 'no-repeat',
        zIndex: this.ZIndex > 0 ? this.ZIndex : this.styles.base['z-index'],
        transform: 'none',
      };
    },
    muted() {
      const { prePlayBgImg, autoPlay = true } = this.configurationData;
      return !prePlayBgImg && autoPlay === true;
    },
    enable() {
      const { playVideoCallBackFlowId = 0 } = this.configurationData;
      const packageStatus = this.quaInfo[playVideoCallBackFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
  },
  watch: {
    'configurationData.prePlayBgImg': {
      handler(newVal) {
        this.prePlayBgImg = newVal;
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('configurationData=  new version video 1.0.5 ', this.configurationData);
    if (this.$isInEditor) return;
    const { prePlayBgImg, playType = PLAY_POSITION_DEFAULT, autoPlay = false } = this.configurationData;
    this.initDomId();
    this.listenPlayBroadcastList();
    // 默认播放
    if (playType === PLAY_POSITION_DEFAULT) {
      const domId = this.setId(this.$refs.defaultPLayVideo);
      console.log('--------domId=', domId);
      if (autoPlay === true) {
        // ios 微信端 自动播放初始化有一块黑布,用户体验不好,需要按照点击播放+背景蒙层处理
        if (!this.$ast.isAPP() && this.$platform.isIos && this.$platform.isWX) {
          console.log('ios 微信端 自动播放初始化有一块黑布,用户体验不好,需要按照点击播放+背景蒙层处理');
          this.$refs.playVideoContainer.addEventListener('click', () => {
            if (!this.isOpenPlayTime(true)) {
              return false;
            }
            if (!this.checkNeedLoginAccess()) {
              return false;
            }
            if (this.init === true) {
              return false;
            }
            this.resetBg();
            this.initPlayer(domId, true);
            this.init = true;
          }, false);
          return;
        }
        // 正常自动播放
        this.$nextTick(() => {
          if (!this.autoPlayTriggerPlayTimeMsg()) {
            return false;
          }
          this.resetBg();
          this.initPlayer(domId, true);
        });
      } else {
        // 点击播放
        if (prePlayBgImg) {
          this.$refs.playVideoContainer.addEventListener('click', () => {
            if (!this.isOpenPlayTime(true)) {
              return false;
            }
            if (!this.checkNeedLoginAccess()) {
              return false;
            }
            // 初始化
            if (this.init === true) {
              return false;
            }
            this.resetBg();
            this.initPlayer(domId, true);
            this.init = true;
          }, false);
          return;
        }
        this.initPlayer(domId, false);
      }
      return;
    }
    // 弹框播放
    if (playType === PLAY_POSITION_POP_WINDOW) {
      const domId = this.setId(this.$refs.popVideo);
      // 蒙层点击关闭
      this.$refs.videoContainerMask.addEventListener(
        'click',
        (event) => {
          if (!this.isOpenPlayTime(true)) {
            return false;
          }
          event && event.stopPropagation();
          // 点击蒙层才触发
          if (
            event.target.attributes.class
            && event.target.attributes.class.nodeValue === 'csu-video-video-container'
          ) {
            const instanceKey = this.getVideoInstanceMakeKey(domId);
            if (window[instanceKey]) {
              window[instanceKey]?.pause();
            }
            this.isShowVideoPlay = false;
          }
        },
        false,
      );
      // 自动播放
      if (autoPlay === true) {
        this.$nextTick(() => {
          if (!this.autoPlayTriggerPlayTimeMsg()) {
            return false;
          }
          this.isShowVideoPlay = true;
          this.initPlayer(domId, true, ['FakeFullscreen', 'Fullscreen']);
        });
        return;
      }
      // 点击播放
      this.$refs.playVideoContainer.addEventListener('click', () => {
        if (!this.isOpenPlayTime(true)) {
          return false;
        }
        if (!this.checkNeedLoginAccess()) {
          return false;
        }
        this.isShowVideoPlay = true;
        this.initPlayer(domId, true, ['FakeFullscreen', 'Fullscreen']);
      }, false);
    }
  },

  methods: {
    autoPlayTriggerPlayTimeMsg() {
      if (!this.isOpenPlayTime(false)) {
        this.$refs.playVideoContainer.addEventListener('click', () => {
          if (!this.isOpenPlayTime(true)) {
            return false;
          }
        }, false);
        return false;
      }
      return true;
    },
    isOpenPlayTime(showError) {
      const {
        isOpenControlTime = false, startTime, endTime,
        noneStartOpenPLayMsg = '',
        noneEndOpenPLayMsg = '',
        timeUnit = PLAT_TIME_CUSTOM_RANGE,
      } = this.configurationData;
      if (!startTime || !isOpenControlTime || !endTime || !timeUnit) {
        console.warn('no access  video play time control ', startTime, isOpenControlTime, endTime, timeUnit);
        return true; //  没有设置开始播放时间 可以直接播放
      }
      const getTimeStamp = function (time) {
        if (time) {
          // ios 的时间格式需要更改一下
          const reTime = time.replace(/-/g, '/');
          return parseInt(new Date(reTime).getTime() / 1000, 10);
        }
        return parseInt(new Date().getTime() / 1000, 10);
      };
      // 在一段时间内播放
      if (timeUnit === PLAT_TIME_CUSTOM_RANGE) {
        const isBiggerThanStartTime = getTimeStamp() >= getTimeStamp(startTime);
        const isLessThanEndTime = getTimeStamp() <= getTimeStamp(endTime);
        if (!isBiggerThanStartTime && showError === true) {
          this.$alert({ msg: noneStartOpenPLayMsg || '未到开放播放时间' });
        }
        if (!isLessThanEndTime && showError === true) {
          this.$alert({ msg: noneEndOpenPLayMsg || '播放时间已结束' });
        }
        return isBiggerThanStartTime && isLessThanEndTime;
      }
      const getCurrentDayTime = function (time) {
        const date = new Date(time.replace(/-/g, '/'));
        const hour = date.getHours(); // 时
        const minutes = date.getMinutes(); // 分
        const seconds = date.getSeconds(); // 秒
        const currentDate = new Date();
        const year = currentDate.getFullYear(); // 年
        const month = currentDate.getMonth() + 1; // 月
        const day = currentDate.getDate(); // 日
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
      };
      const getCurrentDayEndTime = function () {
        const currentDate = new Date();
        const year = currentDate.getFullYear(); // 年
        const month = currentDate.getMonth() + 1; // 月
        const day = currentDate.getDate(); // 日
        return `${year}-${month}-${day} 23:59:59`;
      };
      // 每天播放
      if (timeUnit === PLAT_TIME_PER_DAY_RANGE) {
        const currentStartTime = getCurrentDayTime(startTime);
        const currentEndTime = getCurrentDayTime(endTime);
        const currentDayEndTime = getCurrentDayEndTime();
        console.log('--currentStartTime =', currentStartTime, 'currentEndTime=', currentEndTime, 'currentDayEndTime=', currentDayEndTime);

        const currentTimeStamp = getTimeStamp();
        const startTimeStamp = getTimeStamp(currentStartTime);
        const endTimeStamp = getTimeStamp(currentEndTime);
        const endTimeDayStamp = getTimeStamp(currentDayEndTime);

        if ((currentTimeStamp <= startTimeStamp) && showError === true) {
          this.$alert({ msg: noneStartOpenPLayMsg || '未到开放播放时间' });
        }
        if ((currentTimeStamp >= endTimeStamp && currentTimeStamp <= endTimeDayStamp) && showError === true) {
          this.$alert({ msg: noneEndOpenPLayMsg || '播放时间已结束' });
        }
        return currentTimeStamp >= startTimeStamp && currentTimeStamp <= endTimeStamp;
      }
    },
    initPlayer(domId, playImmediate, removeComps) {
      // https://h5player.woa.com/xy/app/prod/thumbplayer_h5/doc?id=049d6db7017db523
      const { loopPLay = false, vid } = this.configurationData;
      const isLive = vid.indexOf('http') > -1;

      const params = {
        container: `#${domId}`,
        // 自动播放被拦截后是否静音播放
        autoPlayInMute: playImmediate,
        autoPlayPolicy: playImmediate ? AUTO_PLAY_POLICY.IN_MUTED : AUTO_PLAY_POLICY.USER_GESTURE,
        loop: !!loopPLay,
        type: isLive ? PLAT_TYPE_LIVE : PLAT_TYPE_VOD,
        //  去掉清晰度选择 'FakeFullscreen', 'Fullscreen'
        ctrlConfig: {
          removeComps: ['DefinitionPopup'],
        },
        removeComponents: ['info-panel'],
      };
      if (Array.isArray(removeComps) && removeComps.length > 0) {
        params.ctrlConfig.removeComps = [...params.ctrlConfig.removeComps, ...removeComps];
      }
      console.log('playerInstance params---', params);
      const instanceKey = this.getVideoInstanceMakeKey(domId);
      if (!window[instanceKey]) {
        console.log('----new SuperPlayer access 1--');
        window[instanceKey] = new SuperPlayer(params);
        console.log('----new SuperPlayer end 2--');
        const that = this;
        console.log('----new SuperPlayer end 3--');
        window[instanceKey].on('fullscreenChange', ({ data }) => {
          console.log('access browserFullscreenChange playVideo', data);
          const { isEnter = false } = data || {};
          that.ZIndex = isEnter ? 10000 : 0;
        });
        console.log('----new SuperPlayer end 4--');
        window[instanceKey].on(H5_PLAY_EVENT.PLAY_SESSION_END, ({ data }) => {
          const { code, message, endState } = data;
          console.info(`----播放状态码为${code}，错误消息为${message},endState${endState}`);
          if (endState === END_STATE.ERROR) {
            console.error(`----播放出错，错误码为${code}，错误消息为${message}`);
          }
        });
        console.log('----new SuperPlayer end 5--');
        // 播放状态
        window[instanceKey].on('stateChange', ({ data }) => {
          const { new: newStatus = 'playing' } = data;
          if (newStatus === 'playing') {
            // 播放广播
            that.videoBroadCast();
          }
        });
      }
      // player.play({ vid: 't3510uxjwvk' });
      if (!isLive) {
        console.log('----new SuperPlayer play 点播 vid--', vid);
        window[instanceKey].play({ vid });
      } else {
        console.log('----new SuperPlayer play 直播 url--', vid);
        window[instanceKey].play({ url: vid });
      }
      console.log('----new SuperPlayer play 2 --');
      this.reportPlayVideo();
      this.playVideoCallBack();
    },
    pauseVideo() {
      const instanceKey = this.getVideoInstanceMakeKey();
      // 如果暂停中
      if (window[instanceKey] && !window[instanceKey]?.paused) {
        window[instanceKey]?.pause();
      }
    },
    getVideoInstanceMakeKey(domId) {
      return `video-instance-${domId || this.domId}`;
    },
    initDomId() {
      this.domId = this.getRandomId('id-');
    },
    setId(container) {
      const domId = container.id;
      if (!domId) {
        container.setAttribute('id', this.domId);
        return this.domId;
      }
      return domId;
    },
    getRandomId(prefix) {
      return `${prefix}${Math.random().toString(36)
        .slice(-10)}`;
    },
    resetBg() {
      this.prePlayBgImg = '';
    },
    reportPlayVideo() {
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'play_video',
        eventData: {
          status: '1',
          vid: this.configurationData.vid,
        },
      });
    },
    // 有甚至回调流程需要强制登录
    checkNeedLoginAccess() {
      const { playVideoCallBackFlowId = 0, forceLogin = false } = this.configurationData;
      if (playVideoCallBackFlowId > 0 && !this.isLogin && forceLogin === true) {
        this.$alert({ msg: '请先登录' });
        return false;
      }
      return true;
    },
    async playVideoCallBack() {
      const { playVideoCallBackFlowId = 0, playVideoCallBackMsg = '' } = this.configurationData;
      if (playVideoCallBackFlowId > 0 && this.isLogin) {
        if (!this.enable) {
          console.log('playVideoCallBack has access ');
          return false;
        }
        const response = await this.flowRequest({
          flowId: playVideoCallBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('response playVideos CallBack  =', response);
        const { ret: rspRet = 0, data = {} } = response;
        const { ret: ResRet = 0 } = data;
        if (rspRet === 0 && ResRet === 0) {
          if (playVideoCallBackMsg) {
            this.$alert({ msg: playVideoCallBackMsg });
          }
          this.refreshQua(); // 刷新礼包
          return true;
        }
        return false;
      }
    },
    listenPlayBroadcastList() {
      const { multiPlayerPlayControl = false } = this.configurationData;
      if (multiPlayerPlayControl === false) {
        return false;
      }
      const that = this;
      this.$eventBus.$on('ceiba:common:events:videos-play', ({ instanceKey }) => {
        console.log('listen -ceiba:common:events:videos-play - instanceKey = ', instanceKey);
        if (instanceKey && that.getVideoInstanceMakeKey() !== instanceKey) {
          that.pauseVideo();
        }
      });
    },
    videoBroadCast() {
      const { multiPlayerPlayControl = false } = this.configurationData;
      if (multiPlayerPlayControl === false) {
        return false;
      }
      const instanceKey = this.getVideoInstanceMakeKey();
      this.$eventBus.$emit('ceiba:common:events:videos-play', { instanceKey });
    },
    //
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
